module.exports = __webpack_public_path__ + "static/media/twitter.63ddd591.svg";